import React, { createContext, useCallback, useContext, useMemo, useState, useRef } from 'react';

const NeuroaBridgeContext = createContext(null);

export function NeuroaBridgeProvider({ children, onOpenNeuroa }) {
    const [pageContext, setPageContext] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [isNeuroaOpen, setIsNeuroaOpen] = useState(false);
    
    // Proactivity states
    const [showNeuroaWelcome, setShowNeuroaWelcome] = useState(false);
    const [neuroaMessage, setNeuroaMessage] = useState("Conversa con Neuroa");
    
    // Timer refs to prevent overlaps
    const greetingTimerRef = useRef(null);
    const resetTimerRef = useRef(null);

    const openNeuroa = useCallback(() => {
        onOpenNeuroa && onOpenNeuroa();
    }, [onOpenNeuroa]);

    const triggerGreeting = useCallback((message, duration = 3000) => {
        // Clear any existing timers
        if (greetingTimerRef.current) clearTimeout(greetingTimerRef.current);
        if (resetTimerRef.current) clearTimeout(resetTimerRef.current);

        setNeuroaMessage(message);
        setShowNeuroaWelcome(true);
        
        greetingTimerRef.current = setTimeout(() => {
            setShowNeuroaWelcome(false);
            greetingTimerRef.current = null;
            
            // Reset message after fade out
            resetTimerRef.current = setTimeout(() => {
                setNeuroaMessage("Conversa con Neuroa");
                resetTimerRef.current = null;
            }, 500);
        }, duration);
    }, []);

    const value = useMemo(() => ({
        pageContext,
        setPageContext,
        openNeuroa,
        isSidebarOpen,
        setIsSidebarOpen,
        isNeuroaOpen,
        setIsNeuroaOpen,
        showNeuroaWelcome,
        setShowNeuroaWelcome,
        neuroaMessage,
        setNeuroaMessage,
        triggerGreeting
    }), [pageContext, openNeuroa, isSidebarOpen, isNeuroaOpen, showNeuroaWelcome, neuroaMessage, triggerGreeting]);

    return (
        <NeuroaBridgeContext.Provider value={value}>
            {children}
        </NeuroaBridgeContext.Provider>
    );
}

export function useNeuroaBridge() {
    const context = useContext(NeuroaBridgeContext);
    if (!context) {
        throw new Error('useNeuroaBridge must be used within NeuroaBridgeProvider');
    }
    return context;
}
